import React from 'react';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import styles from './SbSharedRefineMenuTypeaheadControls.scss';

export function SbSharedRefineMenuTypeaheadControls(props) {
    const { showSearch, showClear, filterName, categoryL1 } = props;
    const creator = (
        <FormattedMessage
            id="sb.SbMobileRefineMenu.typeahead.controls.filter.creator"
            defaultMessage={`{categoryL1, select,
            art {Artists}
            fashion {Designers}
            other {Creators}
        }`}
            values={{ categoryL1 }}
        />
    );
    const filter = (
        <FormattedMessage
            id="sb.SbMobileRefineMenu.typeahead.controls.filter"
            defaultMessage={`{filterName, select,
            creator {{creator}}
            location {Locations}
            material {Materials}
            metal {Metals}
            origin {Places}
            stone {Stones}
            other {}
        }`}
            values={{ filterName, creator }}
        />
    );
    return (
        <div className={styles.container}>
            <a href="" onClick={props.onToggleClick} data-tn="search">
                <FormattedMessage
                    id="sb.SbMobileRefineMenu.typeahead.controls.toggle"
                    defaultMessage={`{showSearch, select,
                        false {Cancel}
                        true {Search {filter}}
                    }`}
                    values={{ showSearch, filter }}
                />
            </a>
            {showClear && (
                <span className={styles.clear}>
                    <a href="" onClick={props.onClearClick} data-tn="search-clear">
                        <FormattedMessage
                            id="sb.SbMobileRefineMenu.typeahead.controls.clear"
                            defaultMessage="Clear"
                        />
                    </a>
                </span>
            )}
        </div>
    );
}

SbSharedRefineMenuTypeaheadControls.propTypes = {
    filterName: PropTypes.string.isRequired,
    categoryL1: PropTypes.string,
    onToggleClick: PropTypes.func.isRequired,
    onClearClick: PropTypes.func,
    showSearch: PropTypes.bool.isRequired,
    showClear: PropTypes.bool,
};
